var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-message-selector" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("whatsapp_business_api.selectATemplate"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex gap-5" },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: _vm.$t("whatsapp.selectTemplateMessage") },
              model: {
                value: _vm.selectedTemplateId,
                callback: function ($$v) {
                  _vm.selectedTemplateId = $$v
                },
                expression: "selectedTemplateId",
              },
            },
            _vm._l(_vm.templates, function (template) {
              return _c(
                "a-select-option",
                { key: template.id, attrs: { value: template.id } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        template.format === "meta"
                          ? template.name
                          : template.elementName
                      ) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "a-spin",
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "24px" },
                    attrs: { slot: "indicator", type: "loading", spin: "" },
                    slot: "indicator",
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      !!_vm.selectedTemplate
        ? _c("TemplateCard", { attrs: { template: _vm.selectedTemplate } })
        : _vm._e(),
      _vm._v(" "),
      _vm.variables.length > 0 ? _c("a-divider") : _vm._e(),
      _vm._v(" "),
      _vm.variables.length > 0
        ? _c("div", { staticClass: "variables-container" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.variableSettings"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "variables" },
              _vm._l(_vm.variables, function (variable, i) {
                return _c(
                  "div",
                  { key: i, staticClass: "variable" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp.variable")) +
                          " " +
                          _vm._s(i + 1) +
                          " ==> "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.fieldMode
                      ? _c(
                          "a-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("whatsapp.selectVariable"),
                            },
                            model: {
                              value: _vm.variables[i],
                              callback: function ($$v) {
                                _vm.$set(_vm.variables, i, $$v)
                              },
                              expression: "variables[i]",
                            },
                          },
                          _vm._l(_vm.getAvailableParameters(), function (v) {
                            return _c(
                              "a-select-option",
                              { key: v.id, attrs: { value: v.id } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(v.label) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          1
                        )
                      : _c(
                          "a-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("whatsapp.selectVariable"),
                            },
                            model: {
                              value: _vm.variables[i],
                              callback: function ($$v) {
                                _vm.$set(_vm.variables, i, $$v)
                              },
                              expression: "variables[i]",
                            },
                          },
                          _vm._l(_vm.getAvailableParameters(), function (v) {
                            return _c(
                              "a-select-option",
                              { key: v, attrs: { value: v } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(v) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }